// extracted by mini-css-extract-plugin
module.exports = {"soundButton":"SoundButton_soundButton__8UHEB","muted":"SoundButton_muted__tCQgb","bar":"SoundButton_bar__ApqGY","height":"SoundButton_height__biaJZ"};